import { Component, Input } from '@angular/core';
import {CommonModule} from "@angular/common";

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class SpinnerComponent {
  @Input() show: boolean = false;
  // CENTER OF WINDOW, NOT CENTER OF PARENT
  @Input() public showOverContent: boolean = false;
  // CENTER OF PARENT
  @Input() public showOverParent: boolean = false;
}
